import SideBar from "components/our-services/SideBar";
import useLang from "hooks/useLang";
import { useEffect } from "react";
import { Container, Row, Col, Tab } from "react-bootstrap";

const AssistancePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const { lang } = useLang();
  
  return (
    <Container className="text-muted" style={{ paddingTop: "2rem", marginBottom: "50px" }}>
      <h2>{lang.services.lists.list_3.title}</h2>
      <Tab.Container id="assistance-services" defaultActiveKey="first">
        <Row>
          <Row>
            <Col>
              {lang.services.lists.list_3.paragraphs.map(l => <p>{l}</p>)}
            </Col>
            <SideBar />
          </Row>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default AssistancePage;
